/*
 * VEYNOU Suche: Kundensuchen werden in eine genaue Shopify-Suche umgewandelt
 * (title:, product_type:, tag:, Anfuehrungszeichen). Sobald Such-Syntax im Spiel ist,
 * haengt Shopify keine "semantischen" Treffer mehr an (z. B. Arden bei "eden").
 * Kunden sehen weiterhin nur ihren eingegebenen Begriff.
 *
 * Ablauf:
 *  - Suchformular absenden -> Begriff umwandeln -> /search?q=<umgewandelt>&vy=1
 *  - Direkter Aufruf von /search ohne vy=1 -> gleiche Umwandlung, location.replace
 *  - Originalbegriff liegt in sessionStorage (Schluessel = umgewandeltes q) und wird
 *    auf der Ergebnisseite in Suchfeld, Tab-Titel und Texten angezeigt.
 *
 * Wortlisten hier und in sections/predictive-search.liquid gleich halten.
 */
(function () {
  'use strict';

  // Eigene Zaehler-Section (sections/veynou-search-count.liquid), haengt nicht an der
  // wechselnden Template-ID der Suchseite.
  var SECTION_ID = 'veynou-search-count';

  var IGNORED = [
    'gelbgold', 'weißgold', 'weissgold', 'roségold', 'rosegold', 'rotgold', 'platin', 'gold',
    '14kt', '18kt', '585', '750',
    'und', 'mit', 'in', 'aus', 'für', 'der', 'die', 'das', 'ein', 'eine'
  ];

  // Kategorie-Wort -> Shopify-Produkttypen (der erste Typ gilt bei kombinierten Suchen)
  var CATEGORIES = {
    ring: ['Ring', 'Verlobungsringe'],
    ringe: ['Ring', 'Verlobungsringe'],
    kette: ['Kette'],
    ketten: ['Kette'],
    halskette: ['Kette'],
    halsketten: ['Kette'],
    collier: ['Kette'],
    ohrring: ['Ohrring'],
    ohrringe: ['Ohrring'],
    armband: ['Armband'],
    'armbänder': ['Armband'],
    verlobungsring: ['Verlobungsringe'],
    verlobungsringe: ['Verlobungsringe'],
    'anhänger': ['Anhänger']
  };

  var STORAGE_PREFIX = 'vy-search:';
  var HIDE_KEY = 'options[unavailable_products]';
  var EXCLUDE = ' -tag:lastchance';

  // Einzelstuecke (Tag lastchance) nie in der Suche
  function withExclude(q) { return q.indexOf('-tag:lastchance') === -1 ? q + EXCLUDE : q; }

  function hasSyntax(q) {
    return /[:"]/.test(q) || /\sOR\s/.test(q);
  }

  // kleinschreiben, Satzzeichen raus (Komma/Punkt zwischen Ziffern bleibt, z. B. 0,68), ignorierte Woerter raus
  function prepareWords(term) {
    var cleaned = term
      .toLowerCase()
      .replace(/[.,]/g, function (match, offset, str) {
        var before = str.charAt(offset - 1);
        var after = str.charAt(offset + 1);
        return /\d/.test(before) && /\d/.test(after) ? match : ' ';
      })
      .replace(/["'“”„‘’;:!?()\[\]{}\/\\+*&#@^~<>|=_-]/g, ' ');
    return cleaned.split(/\s+/).filter(function (word) {
      return word && IGNORED.indexOf(word) === -1;
    });
  }

  // Nicht-Kategorie-Woerter ab 5 Buchstaben ohne Endung -en, -n, -e, -s
  function stem(word) {
    if (word.length < 5) return word;
    if (/en$/.test(word)) return word.slice(0, -2);
    if (/[nes]$/.test(word)) return word.slice(0, -1);
    return word;
  }

  function fieldFor(word, useStem) {
    if (CATEGORIES[word]) return 'product_type:' + CATEGORIES[word][0];
    return 'title:' + (useStem ? stem(word) : word);
  }

  function buildCandidates(term) {
    var words = prepareWords(term);
    if (!words.length) return [];
    var list = [];

    // 1. genau
    if (words.length === 1 && CATEGORIES[words[0]]) {
      list.push(CATEGORIES[words[0]].map(function (type) { return 'product_type:' + type; }).join(' OR '));
    } else {
      list.push(words.map(function (word) { return fieldFor(word, false); }).join(' '));
    }
    // 2. zusammengeschrieben
    if (words.length > 1) list.push('title:' + words.join(''));
    // 3. ohne Endung (bei einem einzelnen Kategorie-Wort identisch mit 1)
    if (!(words.length === 1 && CATEGORIES[words[0]])) {
      list.push(words.map(function (word) { return fieldFor(word, true); }).join(' '));
    }
    // 4. Tags
    list.push(words.map(function (word) { return 'tag:' + word; }).join(' '));
    // 5. ganzer Begriff als Phrase
    list.push('"' + term.replace(/["“”„]/g, '').trim() + '"');

    return list.filter(function (candidate, index) { return list.indexOf(candidate) === index; });
  }

  function countResults(searchPath, sectionId, type, q) {
    var params = new URLSearchParams();
    params.set('type', type || 'product');
    params.set('q', withExclude(q));
    params.set('options[prefix]', 'last');
    params.set(HIDE_KEY, 'hide');
    params.set('section_id', sectionId);
    return fetch(searchPath + '?' + params.toString(), { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        var match = html.match(/data-vy-count="(\d+)"/);
        return match ? parseInt(match[1], 10) : 0;
      })
      .catch(function () { return 0; });
  }

  // Liefert das erste q mit mindestens 1 Treffer, sonst den Originalbegriff (Shopify-Standard, Tippfehler)
  function transform(term, searchPath, sectionId, type) {
    var candidates = buildCandidates(term);
    var index = 0;
    function next() {
      if (index >= candidates.length) return Promise.resolve(term);
      var candidate = candidates[index++];
      return countResults(searchPath, sectionId, type, candidate).then(function (count) {
        return count > 0 ? candidate : next();
      });
    }
    return next();
  }

  function storeOriginal(q, term) {
    try { sessionStorage.setItem(STORAGE_PREFIX + q, term); } catch (e) { /* kein sessionStorage */ }
  }

  function readable(q) {
    return q
      .replace(/\s*-tag:lastchance/g, '')
      .replace(/\b(title|product_type|tag):/g, '')
      .replace(/\s+OR\s+/g, ' ')
      .replace(/"/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function displayTerm(q) {
    var stored = null;
    try { stored = sessionStorage.getItem(STORAGE_PREFIX + q); } catch (e) { /* kein sessionStorage */ }
    if (stored) return stored;
    return hasSyntax(q) ? readable(q) : q;
  }

  function currentSectionId() {
    return SECTION_ID;
  }

  /* --- Suchformulare abfangen --- */

  function isSearchForm(form) {
    return form && form.tagName === 'FORM' && form.getAttribute('role') === 'search' && form.querySelector('input[name="q"]');
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isSearchForm(form) || event.defaultPrevented) return;
    var input = form.querySelector('input[name="q"]');
    var term = (input.value || '').trim();
    if (!term || hasSyntax(term)) return;

    event.preventDefault();
    var action = new URL(form.getAttribute('action') || '/search', location.href);
    var params = new URLSearchParams(new FormData(form));
    var type = params.get('type');

    transform(term, action.pathname, currentSectionId(), type).then(function (q) {
      var finalQ = withExclude(q);
      storeOriginal(finalQ, term);
      params.set('q', finalQ);
      params.set('vy', '1');
      params.set(HIDE_KEY, 'hide');
      location.href = action.pathname + '?' + params.toString();
    });
  });

  /* --- Ergebnisseite --- */

  function replaceInTextNodes(root, from, to) {
    if (!root || !from || from === to) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf(from) !== -1) node.nodeValue = node.nodeValue.split(from).join(to);
    }
  }

  function showOriginalTerm(q) {
    var shown = displayTerm(q);
    if (shown === q) return;

    document.querySelectorAll('form[role="search"] input[name="q"]').forEach(function (input) {
      if (input.type === 'hidden') return;
      input.value = shown;
      input.setAttribute('value', shown);
    });
    if (document.title.indexOf(q) !== -1) document.title = document.title.split(q).join(shown);

    var container = document.querySelector('.template-search');
    replaceInTextNodes(container, q, shown);

    // nach Filtern/Sortieren (facets.js tauscht HTML aus) erneut ersetzen
    if (container && window.MutationObserver) {
      var timer = null;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () { replaceInTextNodes(container, q, shown); }, 50);
      }).observe(container, { childList: true, subtree: true });
    }
  }

  function initResultsPage() {
    var countElement = document.querySelector('[data-vy-count]');
    if (!countElement) return;
    var params = new URLSearchParams(location.search);
    var q = params.get('q');
    if (!q) return;

    if (!params.has('vy') && !hasSyntax(q)) {
      transform(q, location.pathname, currentSectionId(), params.get('type')).then(function (result) {
        var finalQ = withExclude(result);
        storeOriginal(finalQ, q);
        params.set('q', finalQ);
        params.set('vy', '1');
        params.set(HIDE_KEY, 'hide');
        location.replace(location.pathname + '?' + params.toString() + location.hash);
      });
      return;
    }

    if (params.get(HIDE_KEY) !== 'hide' || q.indexOf('-tag:lastchance') === -1) {
      var finalQ = withExclude(q);
      storeOriginal(finalQ, displayTerm(q));
      params.set(HIDE_KEY, 'hide');
      params.set('q', finalQ);
      location.replace(location.pathname + '?' + params.toString() + location.hash);
      return;
    }

    showOriginalTerm(q);
  }

  /* --- fuer die Suchvorschau (assets/predictive-search.js): Kandidat aus Versuch 1 ohne Trefferpruefung --- */

  window.VySearch = {
    previewQuery: function (term) {
      if (!term || hasSyntax(term)) return null;
      return buildCandidates(term)[0] || null;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initResultsPage);
  } else {
    initResultsPage();
  }
})();
